module.exports = __webpack_public_path__ + "static/media/leading-wellbeing@2x.726981ee.png";